import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import cancelOffer from "astrid-firestore/src/api/offers/cancelOffer";
import offerStatuses, { deleteableOfferStatuses } from "astrid-firestore/src/api/offers/constants/offerStatuses";
import offerTypes from "astrid-firestore/src/api/offers/constants/offerTypes";
import deleteOffer from "astrid-firestore/src/api/offers/deleteOffer";

import { useProfile } from "../../../../authentication/state/profile";
import useHasRight from "../../../../authorization/hooks/useHasRight";
import useProductionTeam from "../../../../productions/hooks/useProductionTeam";

export default function useInquiryOfferDropdownMenuOptions({
	setOfferFormType,
	setOpenTeamMemberForm,
	production,
	offer,
}) {
	const { t } = useTranslation();
	const hasRight = useHasRight();
	const user = useProfile();

	const team = useProductionTeam(production);

	const isTeamMember = team.some((member) => member.user?.id === offer.secondParty?.id);

	const canPrepareOffer =
		!offer.disabled &&
		!isTeamMember &&
		[
			offerStatuses.INITIAL,
			offerStatuses.DRAFT,
			offerStatuses.INTERESTED,
			offerStatuses.CANCELLED,
			offerStatuses.OFFERED,
			offerStatuses.DECLINED,
		].includes(offer.status);

	const canCancelOffer = !isTeamMember && [offerStatuses.OFFERED, offerStatuses.ACCEPTED].includes(offer.status);

	return [
		{
			text: t("prepareInquiry", "Prepare inquiry"),
			onClick: () => setOfferFormType(offerTypes.INQUIRY),
			disabled: !canPrepareOffer,
			hidden: !hasRight("offers.prepare"),
		},
		{
			text: t("sendWorkOrder", "Send work order"),
			onClick: () => setOfferFormType(offerTypes.WORK_ORDER),
			disabled: !canPrepareOffer,
			hidden: !hasRight("offers.send"),
		},
		{
			text: t("cancel", "Cancel"),
			confirmText: t("cancelOfferConfirmation", "Are you sure you want to cancel this offer?"),
			action: () => cancelOffer(firebase, { offer }),
			disabled: !canCancelOffer,
			hidden: !hasRight("offers.send"),
		},
		{
			text: t("alreadyContracted"),
			onClick: () => setOpenTeamMemberForm(true),
			disabled: !canPrepareOffer,
			hidden: !hasRight("offers.prepare"),
		},
		{
			text: t("remove", "Remove"),
			confirmText: t("deleteOfferConfirmation", "Are you sure you want to delete this offer?"),
			action: async () => {
				try {
					await deleteOffer(firebase, { offer, user });
				} catch (error) {
					console.error(error);
					throw new Error(t("failedToDeleteOffer", "Failed to delete offer"));
				}
			},
			disabled: isTeamMember || !deleteableOfferStatuses.includes(offer.status),
			hidden: !hasRight("offers.prepare"),
		},
	];
}
